export default __webpack_public_path__ + "static/media/createLink.4bc987c9.svg";